import { useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { mergedJamSearch, withJamParams } from '../util/recordingNavigation'

export const useRecordingNavigation = () => {
  const history = useHistory()
  const location = useLocation()
  const activeRecordingSearch = useRef('')

  useEffect(() => {
    const mergedSearch = mergedJamSearch(activeRecordingSearch.current, location.search)
    if (!mergedSearch) return

    activeRecordingSearch.current = mergedSearch
    const currentUrl = `${location.pathname}${location.search}${location.hash}`
    const continuedUrl = withJamParams(currentUrl, mergedSearch)
    if (continuedUrl !== currentUrl) history.replace(continuedUrl)
  }, [history, location.pathname, location.search, location.hash])
}
